import ROUTER from '@/routes/ROUTER'
import React from 'react'
import { LazyLoadingComponent } from '..'
const AdminRoutes = React.lazy(() => import('@/pages/SUPPORTPAGES/AdminRoutes'))
const CategoryFunctionManagement = React.lazy(
  () => import('@/features/category-function/container/CategoryFunctionManagement')
)

//Admin
// const OverView = React.lazy(() => import('@/pages/ADMIN/OverView'))
// const ManageMeeting = React.lazy(() => import('@/pages/ADMIN/ManageMeeting'))
const ManageMeetingRoom = React.lazy(() => import('@/pages/ADMIN/ManageMeetingRoom'))
const ListGuest = React.lazy(() => import('@/features/guest-management/container/GuestManagement'))
const EmployeeContact = React.lazy(() => import('@/pages/ADMIN/EmployeeContact'))
// const ViolationDetail = React.lazy(() => import('@/pages/ADMIN/ViolationDetail'))
const EmployeeDirectory = React.lazy(() => import('@/pages/ADMIN/EmployeeDirectory'))
const LeaveStatistics = React.lazy(() => import('@/pages/ADMIN/LeaveStatistics'))
const LeaveDetail = React.lazy(() => import('@/pages/ADMIN/LeaveList/LeaveDetail'))
const WorkSchedule = React.lazy(() => import('@/pages/ADMIN/WorkSchedule'))
const PositionManager = React.lazy(() => import('@/pages/ADMIN/PositionManager'))
const YearCalendar = React.lazy(() => import('@/features/working-calendar'))
const LeaveConfig = React.lazy(() => import('@/pages/ADMIN/LeaveConfig'))
const Role = React.lazy(() => import('@/pages/ADMIN/Role'))
const ApprovalWorkflow = React.lazy(() => import('@/pages/ADMIN/ApprovalWorkflow'))
const BrowseFaceID = React.lazy(() => import('@/pages/ADMIN/BrowseFaceID'))
const BrowseEmployeeAccount = React.lazy(
  () => import('@/pages/ADMIN/BrowseEmployeeAccount/EmployeeAccount')
)
// const BrowseEmployeeLeave = React.lazy(() => import('@/pages/ADMIN/BrowseEmployeeLeave'))
const EntryList = React.lazy(() => import('@/pages/ADMIN/EntryList'))
const BrowseChangeInformation = React.lazy(() => import('@/pages/ADMIN/BrowseChangeInformation'))
const AttendanceReport = React.lazy(() => import('@/pages/ADMIN/AttendanceReport'))
const AttendanceReportV2 = React.lazy(() => import('@/pages/ADMIN/AttendanceReportV2'))
// const EventManagement = React.lazy(() => import('@/features/acs/event-management'))
const Devices = React.lazy(() => import('@/pages/ADMIN/Devices'))
const DoorManagement = React.lazy(() => import('@/pages/ADMIN/DoorManagement'))
const ChargerInfo = React.lazy(() => import('@/pages/ADMIN/ChargerManage'))
const CameraInfo = React.lazy(() => import('@/pages/ADMIN/CameraInfo'))
const VehicleManagement = React.lazy(() => import('@/pages/ADMIN/VehicleManagement'))
const MeetingManage = React.lazy(() => import('@/pages/ADMIN/MeetingManagement'))
const CheckedInList = React.lazy(() => import('@/pages/ADMIN/CheckedInList'))
const EmployeeList = React.lazy(() => import('@/pages/ADMIN/EmployeeList'))
// const _ManageEntry = React.lazy(() => import('@/pages/ADMIN/ManageEntry'))
const DayOffInfromation = React.lazy(() => import('@/pages/ADMIN/DayOffInfromation'))
const GuestMeetingDetails = React.lazy(() => import('@/pages/ADMIN/GuestMeetingDetails'))

const PresentCheck = React.lazy(() => import('@/pages/ADMIN/PresentCheck'))
const PresentCheckList = React.lazy(() => import('@/pages/ADMIN/PresentCheckList'))

const JobPositions = React.lazy(() => import('@/pages/ADMIN/JobPositions'))
export const adminRoutes = [
  // ADMIN
  {
    element: (
      <LazyLoadingComponent>
        <AdminRoutes />
      </LazyLoadingComponent>
    ),
    children: [
      {
        path: ROUTER.CAU_HINH_LUONG_DUYET,
        element: (
          <LazyLoadingComponent>
            <ApprovalWorkflow />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.QUAN_LY_PHONG_HOP,
        element: (
          <LazyLoadingComponent>
            <ManageMeetingRoom />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DANH_SACH_KHACH,
        element: (
          <LazyLoadingComponent>
            <ListGuest />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DANH_BA_NHAN_VIEN,
        element: (
          <LazyLoadingComponent>
            <EmployeeDirectory />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.CAI_DAT_TAI_KHOAN,
        element: (
          <LazyLoadingComponent>
            <EmployeeContact />
          </LazyLoadingComponent>
        ),
      },
      // {
      //   path: ROUTER.NHAN_VIEN_DA_NGHI,
      //   element: (
      //     <LazyLoadingComponent>
      //       <EmployeeContactManage type={2} />
      //     </LazyLoadingComponent>
      //   ),
      // },
      {
        path: ROUTER.NGHI_PHEP_LIST,
        element: (
          <LazyLoadingComponent>
            <LeaveStatistics />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.CHI_TIET_NGHI_PHEP,
        element: (
          <LazyLoadingComponent>
            <LeaveDetail />
          </LazyLoadingComponent>
        ),
      },
      // {
      //   path: ROUTER.CHI_TIET_VI_PHAM,
      //   element: (
      //     <LazyLoadingComponent>
      //       <ViolationDetail />
      //     </LazyLoadingComponent>
      //   ),
      // },
      {
        path: ROUTER.LiCH_LAM_VIEC_LAM_BU,
        element: (
          <LazyLoadingComponent>
            <WorkSchedule />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DANH_SACH_CHUC_VU,
        element: (
          <LazyLoadingComponent>
            <PositionManager />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.LICH_NAM,
        element: (
          <LazyLoadingComponent>
            <YearCalendar />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.CAU_HINH_NGHI_PHEP,
        element: (
          <LazyLoadingComponent>
            <LeaveConfig />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.QUAN_LY_PHAN_QUYEN,
        element: (
          <LazyLoadingComponent>
            <Role />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.QUAN_LY_DANH_MUC_CHUC_NANG,
        element: (
          <LazyLoadingComponent>
            <CategoryFunctionManagement />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DUYET_FACE_ID,
        element: (
          <LazyLoadingComponent>
            <BrowseFaceID />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DUYET_TAI_KHOAN_NHAN_VIEN,
        element: (
          <LazyLoadingComponent>
            <BrowseEmployeeAccount />
          </LazyLoadingComponent>
        ),
      },
      // {
      //   path: ROUTER.DUYET_DON_NGHI,
      //   element: (
      //     <LazyLoadingComponent>
      //       <BrowseEmployeeLeave />
      //     </LazyLoadingComponent>
      //   ),
      // },
      {
        path: ROUTER.THONG_TIN_CHECK_IN,
        element: (
          <LazyLoadingComponent>
            <EntryList />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DUYET_THAY_DOI_THONG_TIN,
        element: (
          <LazyLoadingComponent>
            <BrowseChangeInformation />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.THONG_KE_RA_VAO,
        element: (
          <LazyLoadingComponent>
            <AttendanceReport />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.THONG_KE_RA_VAO_V2,
        element: (
          <LazyLoadingComponent>
            <AttendanceReportV2 />
          </LazyLoadingComponent>
        ),
      },

      {
        path: ROUTER.THONG_TIN_THIET_BI,
        element: (
          <LazyLoadingComponent>
            <Devices />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.QUAN_LY_CUA,
        element: (
          <LazyLoadingComponent>
            <DoorManagement />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.TRAM_SAC,
        element: (
          <LazyLoadingComponent>
            <ChargerInfo />
          </LazyLoadingComponent>
        ),
      },
      {
        path: `${ROUTER.CAMERA}/:id`,
        element: (
          <LazyLoadingComponent>
            <CameraInfo />
          </LazyLoadingComponent>
        ),
      },
      {
        path: `${ROUTER.QUAN_LY_PHUONG_TIEN}/:id`,
        element: (
          <LazyLoadingComponent>
            <VehicleManagement />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DANH_SACH_CUOC_HOP,
        element: (
          <LazyLoadingComponent>
            <MeetingManage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DANH_SACH_NHAN_VIEN_DA_CHECK_IN,
        element: (
          <LazyLoadingComponent>
            <CheckedInList />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DANH_SACH_NHAN_VIEN,
        element: (
          <LazyLoadingComponent>
            <EmployeeList />
          </LazyLoadingComponent>
        ),
      },
      {
        path: `${ROUTER.DIEM_DANH_HOP}/:meetingId`,
        element: (
          <LazyLoadingComponent>
            <PresentCheck />
          </LazyLoadingComponent>
        ),
      },
      {
        path: `${ROUTER.DANH_SACH_DAI_BIEU}/:meetingId/:type`,
        element: (
          <LazyLoadingComponent>
            <PresentCheckList />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.CHI_TIET_KHACH_HEN,
        element: (
          <LazyLoadingComponent>
            <GuestMeetingDetails />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.THONG_KE_NGHI_PHEP_SYSTEM,
        element: (
          <LazyLoadingComponent>
            <DayOffInfromation />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.QUAN_LY_VI_TRI,
        element: (
          <LazyLoadingComponent>
            <JobPositions />
          </LazyLoadingComponent>
        ),
      },
    ],
  },
]
